import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { useAppSelector } from "../../../../../redux/hooks";
import { conditions } from "../../../../../helpers";
import { ConditionName } from "../../../../../interfaces";
import IMAGES from "../../../../../images/importImages";
import { handleClickViewersTagList, handleCloseSelectedTags, handleNextTag, handlePrevTag } from "../../../../../redux/actions/tags.actions";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const CloseIcon = dynamic(() => import("../../icon-components/closeIcon"));

const ViewersTagsList = () => {

    const [tagsSlideArrow, setTagsSlideArrow] = useState<boolean>(false);
    const [tagSlideScrollLeft, setTagSlideScrollLeft] = useState<number>(0);

    const { selectedTags, viewersTagsList } = useAppSelector(({ tags: { selectedTags, viewersTagsList } }) => ({ selectedTags, viewersTagsList }), shallowEqual);

    const tagsContainerRef = useRef<any>(null);

    useEffect(() => {
        if (tagsContainerRef.current) {
            const clientWidth = tagsContainerRef.current.clientWidth;
            const scrollWidth = tagsContainerRef.current.scrollWidth;
            setTagsSlideArrow(scrollWidth > clientWidth);
            setTagSlideScrollLeft(tagsContainerRef.current.scrollLeft);
            tagsContainerRef.current.addEventListener('scroll', (e: any) => setTagSlideScrollLeft(e.target.scrollLeft));
        }
        return () => tagsContainerRef.current && tagsContainerRef.current.removeEventListener('scroll', () => true);

    }, [tagsContainerRef.current]);
    
    return (
        <div className="pl-viewers-tag-list pl-flex pl-gap-2 !pl-overflow-x-auto no-scrollbar pl-mb-4 pl-mx-4" ref={tagsContainerRef}>
            {
                tagsContainerRef.current && tagsSlideArrow && !conditions(ConditionName.isTouchScreen) && (
                    <>
                        {
                            tagSlideScrollLeft < 0 && (
                                <div className={`pl-tags-scroll-icon pl-hidden pl-items-center pl-justify-center pl-cursor-pointer pl-transition hover:pl-scale-[1.2] pl-drop-shadow-lg pl-absolute pl-rounded-full pl-mt-1`} onClick={(event: any) => handlePrevTag(event, tagsContainerRef)}>
                                    <Image src={IMAGES.chevronCircleRight} width={18} height={18} alt="chevronCircleRight-icon" />
                                </div>
                            )
                        }
                        {
                            Math.abs(tagSlideScrollLeft - tagsContainerRef.current.clientWidth) !== tagsContainerRef.current.scrollWidth - 1 && (
                                <div className={`pl-tags-scroll-icon pl-hidden pl-items-center pl-justify-center pl-cursor-pointer pl-transition hover:pl-scale-[1.2] -pl-rotate-180 pl-drop-shadow-lg pl-absolute pl-left-2 pl-rounded-full pl-mt-1`} onClick={(event: any) => handleNextTag(event, tagsContainerRef)}>
                                    <Image src={IMAGES.chevronCircleRight} width={18} height={18} alt="chevronCircleRight-icon" />
                                </div>
                            )
                        }
                    </>
                )
            }
            {conditions(ConditionName.hasSelectedTags) && selectedTags.map((tag: string) => (
                <div className="pl-flex pl-items-center pl-gap-[10px] pl-bg-dark-2 dark:pl-bg-dark-5 pl-text-gray-highLight dark:pl-text-gray-800 pl-whitespace-nowrap pl-px-2 pl-py-1 pl-rounded-[4px] pl-text-[10px] pl-font-normal" key={tag}>
                    <button className="pl-cursor-default">{tag}</button>
                    <CloseIcon className="pl-w-[13px] pl-h-[13px] pl-stroke-gray-highLight dark:pl-stroke-gray-800 pl-cursor-pointer" onClick={() => handleCloseSelectedTags(tag)} />
                </div>
            ))}
            {(conditions(ConditionName.isTouchScreen) && !!viewersTagsList.length) && viewersTagsList.map((tag: string) => (
                <button
                    key={tag}
                    onClick={() => handleClickViewersTagList(tag)}
                    className="pl-text-z-gray-700 dark:pl-text-dark-5 pl-bg-gray-100 dark:pl-bg-dark-2 pl-border pl-border-secondary pl-whitespace-nowrap pl-px-2 pl-py-1 pl-rounded-[4px] pl-text-[10px] pl-font-normal"
                >
                    {tag}
                </button>
            ))}
        </div>

    )
}

export default ViewersTagsList;